import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import GL_DARK from "../../../../assets/GlobalLogic_dark_logo.svg";
import GL from "../../../../assets/GlobalLogic_logo.svg";
import { RootState, useAppSelector } from "../../../../store/store";
import { useState } from "react";
import { removeInlineColors } from "@assessment/utils/global/removeInlineColor";
import Modal from "@assessment/components/atoms/modal";
import Button from "@assessment/components/atoms/button";
import FaqQuestionAndAnswerModal from "./faq/faqQuetionAndAnsModal";
import Instructions from "../instructions";
import hitachiLogo from "@lxp-app/assets/svg/hitachiLogo.svg";
import glLogo from "@lxp-app/assets/png/glLogo.png";
import hitachiDarkLogo from "@lxp-app/assets/svg/hitachiDarkLogo.svg";
import glDarkLogo from "@lxp-app/assets/svg/GlDarkLogo.svg";
import orgBasedFeatureNameMapping from "@assessment/utils/orgBasedFeatureName";
// interface DetailsCardProps {}
const DetailsCard = () => {
  const { t } = useTranslation();
  const { isDarkMode } = useSelector((state: any) => state.DarkmodeSlice);
  const [openModal, setOpenModal] = useState(false);
  const preAssessmentData = useAppSelector(
    (state) => state.AssessmentSlice.preAssessmentData
  );
  const user = useSelector((state: RootState) => state.UserInfoSlice);
  const hasAssessmentRecOrgs = user?.profile.hasAssessmentRecOrgs;
  const userFirstName = useAppSelector(
    (state) => state.AssessmentSlice.candidateDetails.firstName
  );

  // const numberOfQuestions = preAssessmentData
  //   ? Object.values(preAssessmentData?.questionTypeCountMap).reduce(
  //       (sum: any, value: any) => sum + value,
  //       0
  //     )
  //   : 0;
  const numberOfQuestions = preAssessmentData?.questionTypeCountMap
    ? Object.values(preAssessmentData.questionTypeCountMap).reduce(
        (sum: number, value: number) => sum + value,
        0
      )
    : 0;

  const qpDuration = preAssessmentData?.qpDuration;
  const [isFaqModalOpen, setFaqModalOpen] = useState(false);
  const isHitachiOrg = useSelector(
    (state: RootState) => state.UserInfoSlice.profile.isHitachiOrg
  );

  const scheduleInstruction = removeInlineColors(
    preAssessmentData?.scheduleInstruction
  );

  const orgBasedFeatureName =
    orgBasedFeatureNameMapping[(user?.org as string) || "default"] ||
    orgBasedFeatureNameMapping["default"];

  return (
    <div className="flex flex-col w-full lg:w-[45%] px-6 md:px-10 lg:px-12 py-6 lg:py-10 overflow-y-auto max-h-[calc(100vh-100px)] thin-scrollbar">
      {/* Logo */}
      {isHitachiOrg ? (
        <div className="flex items-center h-full">
          <img
            onContextMenu={(e) => e.preventDefault()}
            style={{
              userSelect: "none",
              cursor: "pointer"
            }}
            className="h-9 md:h-10"
            src={isDarkMode ? hitachiDarkLogo : hitachiLogo}
            alt="hitachiLogo"
          />
          <div className="w-0.5 bg-[#D40000] h-9 mx-2"></div>
          <img
            onContextMenu={(e) => e.preventDefault()}
            style={{
              userSelect: "none",
              cursor: "pointer"
            }}
            className="h-9 md:h-10"
            src={isDarkMode ? glDarkLogo : glLogo}
            alt="glLogo"
          />
        </div>
      ) : (
        <img
          src={isDarkMode ? GL_DARK : GL}
          alt="GlobalLogic Logo"
          className="-ml-5 w-72"
        />
      )}

      {/* Name & Title */}
      <div className="mt-10 space-y-2">
        <h3 className="text-base sm:text-lg font-medium text-secondary/70">
          {t("assessment.labels.welcome")},{" "}
          <span>
            {user.profile.name.firstName ||
              userFirstName ||
              t("assessment.labels.userFallback")}
          </span>
        </h3>
        <h1 className="text-2xl sm:text-3xl font-semibold text-primary break-words">
          {preAssessmentData?.title}
        </h1>
      </div>

      {/* Meta Info */}
      <div className="flex flex-wrap mt-10 gap-y-4 gap-x-8 text-sm  sm:text-base">
        <div>
          <h3 className="font-medium">
            {t("assessment.labels.totalDuration")}
          </h3>
          <p className="text-secondary/70">
            {qpDuration} {t("assessment.labels.minutes")}
          </p>
        </div>
        <div>
          <h3 className="font-medium">
            {t("assessment.labels.numberOfQuestions")}
          </h3>
          <p className="text-secondary/70">{numberOfQuestions}</p>
        </div>
        <div>
          <h3 className="font-medium">
            {t("assessment.labels.numberOfSections")}
          </h3>
          <p className="text-secondary/70">
            {preAssessmentData?.no_of_sections}
          </p>
        </div>
      </div>

      {/* Instructions */}
      <div className="flex-1 mt-10 space-y-2 mb-4">
        <h2 className="text-xl font-medium text-secondary">
          {t("assessment.labels.guidelines")}
        </h2>
        <div className="remove-tailwind text-left">
          <div className="w-full max-w-full overflow-hidden">
            <div
              style={{
                width: "fit-content",
                height: "fit-content"
              }}
              className="min-w-full min-h-full"
            >
              <div className="remove-tailwind text-left">
                {scheduleInstruction ? (
                  <div className="w-full max-w-full overflow-hidden">
                    <div
                      className={`text-left rich-text-container`}
                      dangerouslySetInnerHTML={{
                        __html: scheduleInstruction
                      }}
                    />
                  </div>
                ) : (
                  <div className="text-left rich-text-container">
                    {t("assessment.labels.defaultGuidelines", {
                      featureName: orgBasedFeatureName
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {preAssessmentData?.qpInstruction &&
        preAssessmentData?.qpInstruction.length > 0 && (
          <div onClick={() => setOpenModal(!openModal)}>
            <Button
              label={t("assessment.labels.showFeatureInstructions", {
                featureName: orgBasedFeatureName
              })}
              variant="contained"
              buttonColor="secondary"
              className="w-full"
            />
          </div>
        )}

      {/* Links */}
      <div className="flex justify-start gap-3 mt-10 items-center">
        <span className="text-blue-500 underline underline-offset-1">
          <a
            className="text-sm font-medium cursor-pointer"
            href={
              hasAssessmentRecOrgs && !isHitachiOrg
                ? "https://mail.google.com/mail/?view=cm&fs=1&to=amith.c@globallogic.com"
                : "https://mail.google.com/mail/?view=cm&fs=1&to=support.glx@globallogic.com"
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("assessment.labels.platformHelp")}
          </a>
        </span>
        <div className="w-px h-4 bg-blue-500" />
        <p
          className="text-sm font-medium text-blue-500 underline cursor-pointer"
          onClick={() => setFaqModalOpen(true)}
        >
          {t("assessment.labels.faq")}
        </p>
      </div>
      <div>
        <Modal
          open={isFaqModalOpen}
          dialogueClassName="w-[100%] sm:w-[50%] max-h-[75vh] overflow-y-auto thin-scrollbar sm:p-6"
          // dialogueClassName="sm:max-w-fit sm:mx-10"
          // dialogueClassName= "sm:max-w-3xl p-4"
          childDialogTitle={t("assessment.labels.frequentlyAskedQuestions")}
          closeBtn={true}
          children={<FaqQuestionAndAnswerModal setOpen={setFaqModalOpen} />}
        />
      </div>
      <Modal
        open={openModal}
        children={<Instructions instructionType={["qp"]} />}
        dialogueClassName="w-[80vw]"
        childDialogTitle={t("common.instructions")}
        setOpen={setOpenModal}
      />
    </div>
  );
};

export default DetailsCard;
